document.addEventListener('DOMContentLoaded', function () {

  const slider = document.querySelector('.ht-slider');
  const slides = document.querySelectorAll('.ht-slide');
  const dotsContainer = document.querySelector('.ht-dots');
  const prevBtn = document.querySelector('.ht-prev');
  const nextBtn = document.querySelector('.ht-next');

  if (!slider || slides.length === 0) return;

  let current = 0;
  let autoPlay;

  /* Create dots */
  slides.forEach((slide, index) => {

    const dot = document.createElement('span');
    dot.classList.add('ht-dot');

    dot.addEventListener('click', () => {
      current = index;
      updateSlider();
      restartAutoPlay();
    });

    dotsContainer.appendChild(dot);

  });

  const dots = document.querySelectorAll('.ht-dot');

  function updateSlider() {

    slides.forEach(slide => {
      slide.classList.remove('active');
    });

    dots.forEach(dot => {
      dot.classList.remove('active');
    });

    slides[current].classList.add('active');

    if (dots[current]) {
      dots[current].classList.add('active');
    }

    /* Desktop preview cards */

    if (window.innerWidth > 768) {

      const prevIndex =
        (current - 1 + slides.length) % slides.length;

      const nextIndex =
        (current + 1) % slides.length;

      slides[prevIndex].style.display = 'block';
      slides[nextIndex].style.display = 'block';

      slides.forEach((slide, index) => {

        if (
          index !== current &&
          index !== prevIndex &&
          index !== nextIndex
        ) {
          slide.style.display = 'none';
        }

      });

    } else {

      slides.forEach(slide => {
        slide.style.display = 'none';
      });

      slides[current].style.display = 'block';

    }

  }

  function nextSlide() {

    current++;

    if (current >= slides.length) {
      current = 0;
    }

    updateSlider();

  }

  function prevSlide() {

    current--;

    if (current < 0) {
      current = slides.length - 1;
    }

    updateSlider();

  }

  /* Buttons */

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      restartAutoPlay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      restartAutoPlay();
    });
  }

  /* Auto Slide */

  function startAutoPlay() {

    autoPlay = setInterval(() => {
      nextSlide();
    }, 5000);

  }

  function restartAutoPlay() {

    clearInterval(autoPlay);
    startAutoPlay();

  }

  /* Touch Swipe Mobile */

  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', function(e){

    touchStartX = e.changedTouches[0].screenX;

  });

  slider.addEventListener('touchend', function(e){

    touchEndX = e.changedTouches[0].screenX;

    if (touchStartX - touchEndX > 50) {
      nextSlide();
      restartAutoPlay();
    }

    if (touchEndX - touchStartX > 50) {
      prevSlide();
      restartAutoPlay();
    }

  });

  window.addEventListener('resize', function () {

    updateSlider();

  });

  updateSlider();
  startAutoPlay();

});